// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banzufenbao[data-v-4cce5688] {
  width: 100%;
}
.banzufenbao .box[data-v-4cce5688] {
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
}
.banzufenbao .form-box[data-v-4cce5688] {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/views/BillPricingSoftware/ConstructionCostBudget/Banzufenbao.vue","webpack://./Banzufenbao.vue"],"names":[],"mappings":"AACA;EACE,WAAA;ACAF;ADDA;EAGI,YAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;ACCJ;ADTA;EAWI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;ACCJ","sourcesContent":["\n.banzufenbao {\n  width: 100%;\n  .box {\n    height: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-direction: column;\n    width: 100%;\n  }\n  .form-box {\n    position: relative;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-start;\n    width: 100%;\n    gap: 10px;\n  }\n}\n",".banzufenbao {\n  width: 100%;\n}\n.banzufenbao .box {\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: column;\n  width: 100%;\n}\n.banzufenbao .form-box {\n  position: relative;\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-start;\n  width: 100%;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
